import mImport from './Main.vue';

export default mImport;
